<template>
  <a-modal class="date-modal-css" v-model="showModal" title="新增" width="1000px" :maskClosable="false" :closable="true" :destroyOnClose="true">
    <a-form-model ref="baseForm" :model="formData">
      <a-row>
        <a-col :md="12" :sm="24">
          <a-form-model-item
            label="供应商编码"
            prop="vendorCode"
            :labelCol="{ style: 'width: 120px;float:left' }"
            :rules="{'required':true,'message':' ','trigger':'change'}"
            :wrapperCol="{ style:'width:calc(100% - 120px) !important;float:left'}"
          >
            <global-select
              :value.sync="formData.vendorCode"
              selectType="selectSearch"
              requestApi="/mdm/mdmOrgSupplier/supplierCodeList"
              :selectItem="{ value: 'label', label: 'label' }"
              searchParam="supplierCode"
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item
            label="物料编码"
            prop="itemCode"
            :labelCol="{ style: 'width: 120px;float:left' }"
            :rules="{'required':true,'message':' ','trigger':'change'}"
            :wrapperCol="{ style:'width:calc(100% - 120px) !important;float:left'}"
          >
            <global-select
              :value.sync="formData.itemCode"
              selectType="selectSearch"
              requestApi="/mes/mesDiscreteJobs/assemblyBox"
              :selectItem="{ value: 'selectedValue', label: 'label' }"
              searchParam="itemCode"
              :dropdown-match-select-width="false"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :md="12" :sm="24">
          <a-form-model-item
            label="首件是否通过"
            prop="firstPieceState"
            :labelCol="{ style: 'width: 120px;float:left' }"
            :wrapperCol="{ style:'width:calc(100% - 120px) !important;float:left'}"
          >
            <a-select v-model="formData.firstPieceState" allowClear>
              <a-select-option :value="'1'">是</a-select-option>
              <a-select-option :value="'0'">否</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item
            label="首5件是否通过"
            prop="firstFivePieceState"
            :labelCol="{ style: 'width: 120px;float:left' }"
            :wrapperCol="{ style:'width:calc(100% - 120px) !important;float:left'}"
          >
            <a-select v-model="formData.firstFivePieceState" allowClear>
              <a-select-option :value="'1'">是</a-select-option>
              <a-select-option :value="'0'">否</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item
            label="大货改善评估是否通过"
            prop="bigGoodsEvaluationState"
            :labelCol="{ style: 'width: 145px;float:left' }"
            :wrapperCol="{ style:'width:calc(100% - 145px) !important;float:left'}"
          >
            <a-select v-model="formData.bigGoodsEvaluationState" allowClear>
              <a-select-option :value="'1'">是</a-select-option>
              <a-select-option :value="'0'">否</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item
            label="备注"
            prop="remark"
            :labelCol="{ style: 'width: 120px;float:left' }"
            :wrapperCol="{ style:'width:calc(100% - 120px) !important;float:left'}"
          >
            <a-input type="textarea" :autoSize="{minRows:2}" v-model="formData.remark" :maxLength="200" />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <template #footer>
      <div class="footer-btn-wrapper">
        <a-button @click="onCancel">取消</a-button>
        <a-button type="primary" :loading="loading" @click="onSubmit">确认</a-button>
      </div>
    </template>
  </a-modal>
</template>

<script>
import moment from 'moment';
import { apiScpOrderCheckItemAdd } from '@/api/mes/basedata/orderInspectionMaintenance'
import cloneDeep from 'lodash.clonedeep'
export default {
  name: 'AddMaintenance',
  data () {
    return {
      loading: false,
      showModal: false,
      formData: {
        vendorCode: undefined, // 供应商编码
        itemCode: undefined, // 物料编码
        firstPieceState: undefined, // 首件是否通过
        firstFivePieceState: undefined, // 首5件是否通过
        bigGoodsEvaluationState: undefined // 大货改为评审是否通过
      }
    }
  },
  props: {
    loopUpData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  methods: {
    moment,
    show(form) {
      this.reset()
      if(form?.vendorCode) {
        this.formData = cloneDeep(form)
      }
      this.showModal = true
    },
    onCancel() {
      this.showModal = false
    },
    reset() {
      this.formData = {
        vendorCode: undefined, // 供应商编码
        itemCode: undefined, // 物料编码
        firstPieceState: undefined, // 首件是否通过
        firstFivePieceState: undefined, // 首5件是否通过
        bigGoodsEvaluationState: undefined // 大货改为评审是否通过
      }
    },
    // 提交
    onSubmit() {
      this.$refs.baseForm.validate(valid => {
        if(valid) {
          this.loading = true
          apiScpOrderCheckItemAdd(this.formData).then(res => {
            if (res.code === 200) {
              this.$message.success(this.formData.id ? '修改成功' : '新增成功')
              this.$emit('refreshFun', this.formData)
              this.showModal = false
            }
          }).finally(() => {
            this.loading = false
          })
        } else {
          this.$message.warning('请检查必填项')
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
